import React, { Component } from 'react';
import { Divider, Button, FormGroup, InputGroup, NumericInput } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class ServerSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serverName: 'Last World Online [Cap 110]',
      gatewayIp: '127.0.0.1',
      gatewayPort: 15884,
      agentPort: 15882,
      maxLevelCap: 110,
      pcLimit: 2,
      ipLimit: 4,
      saved: false
    };
  }

  handleSave = (e) => {
    e.preventDefault();
    this.setState({ saved: true });
    setTimeout(() => this.setState({ saved: false }), 3000);
  };

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Server Core Settings
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Configure Silkroad Gateway nodes, Agent listener ports, max level cap, and Hardware ID PC/IP limits.
        </p>

        <Divider className="mb-4" />

        {this.state.saved && (
          <div className="alert alert-success py-2 mb-4" style={{ fontSize: '0.85rem' }}>
            Server Configuration saved and applied to SROFilter Core Engine!
          </div>
        )}

        <form onSubmit={this.handleSave}>
          <div className="row mb-3">
            <div className="col-md-6">
              <FormGroup label="Server Display Name" labelFor="server-name">
                <InputGroup
                  id="server-name"
                  value={this.state.serverName}
                  onChange={(e) => this.setState({ serverName: e.target.value })}
                />
              </FormGroup>
            </div>

            <div className="col-md-6">
              <FormGroup label="Gateway Server IP Address" labelFor="gw-ip">
                <InputGroup
                  id="gw-ip"
                  value={this.state.gatewayIp}
                  onChange={(e) => this.setState({ gatewayIp: e.target.value })}
                />
              </FormGroup>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-4">
              <FormGroup label="Gateway Port">
                <NumericInput
                  value={this.state.gatewayPort}
                  onValueChange={(val) => this.setState({ gatewayPort: val })}
                  fill
                />
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup label="Agent Listener Port">
                <NumericInput
                  value={this.state.agentPort}
                  onValueChange={(val) => this.setState({ agentPort: val })}
                  fill
                />
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup label="Max Level Cap">
                <NumericInput
                  value={this.state.maxLevelCap}
                  onValueChange={(val) => this.setState({ maxLevelCap: val })}
                  fill
                />
              </FormGroup>
            </div>
          </div>

          <Divider className="my-4" />

          <h5 className="mb-3 font-weight-bold" style={{ color: '#182026' }}>Hardware & Security Limits</h5>

          <div className="row mb-4">
            <div className="col-md-6">
              <FormGroup label="Max Accounts per PC Hardware ID (HWID)">
                <NumericInput
                  min={1}
                  max={10}
                  value={this.state.pcLimit}
                  onValueChange={(val) => this.setState({ pcLimit: val })}
                  fill
                />
              </FormGroup>
            </div>

            <div className="col-md-6">
              <FormGroup label="Max Connections per Public IP Address">
                <NumericInput
                  min={1}
                  max={20}
                  value={this.state.ipLimit}
                  onValueChange={(val) => this.setState({ ipLimit: val })}
                  fill
                />
              </FormGroup>
            </div>
          </div>

          <Button intent="primary" type="submit" icon="floppy-disk" small text="Save Server Settings" />
        </form>
      </SideMenuWrapper>
    );
  }
}
